import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Skill } from "./skills_utilization";
import css from "./skills_utilization.module.scss";

type CountItemProps = {
  count: number | null;
  skill: Skill | null;
  countLabelKey: "countActiveRoles" | "countPeople";
  foundItemLabelKey: "haveSkillRequirement" | "haveSkillOnProfile";
  linkLabelKey: "viewYours" | "viewAll";
  linkTo: object;
};

export const CountItem = ({
  count,
  skill,
  countLabelKey,
  foundItemLabelKey,
  linkLabelKey,
  linkTo
}: CountItemProps): JSX.Element => {
  const { t } = useTranslation("insights");
  return (
    <div className={css.spacing}>
      <div>
        <Trans i18nKey={countLabelKey} t={t} components={[<strong key="0" />]} count={count || 0} />
      </div>
      {skill && (
        <>
          {t(foundItemLabelKey, { skill: skill.text })}{" "}
          {count && count > 0 && <Link to={linkTo}>{t(linkLabelKey)}</Link>}
        </>
      )}
    </div>
  );
};
